import { render, staticRenderFns } from "./RequiredText.vue?vue&type=template&id=4e9ab8f3&scoped=true&"
import script from "./RequiredText.vue?vue&type=script&lang=js&"
export * from "./RequiredText.vue?vue&type=script&lang=js&"
import style0 from "./RequiredText.vue?vue&type=style&index=0&id=4e9ab8f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9ab8f3",
  null
  
)

export default component.exports